<template>
  <component :is="'b-card'">
    <div class="physician-form">
      <validation-observer ref="refFormObserver" #default="{ handleSubmit }">
        <b-form
          @submit.prevent="handleSubmit(save)"
        >
          <b-tabs
            pills
          >
            <b-tab active>
              <template #title>
                <div>
                  <feather-icon
                    icon="UserIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                  />
                  <span class="d-none d-sm-inline">Geral</span>
                </div>
              </template>

              <b-row>
                <b-col cols="12" md="12" xl="8">
                  <validation-provider
                    #default="validationContext"
                    name="Nome"
                    rules="required"
                  >
                    <b-form-group
                      label="Nome"
                      label-for="nome"
                    >
                      <b-form-input
                        id="nome"
                        v-model="workplaceLocal.name"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="Nome"
                      />
                      <small class="text-danger">{{ validationContext.errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="12" xl="8">
                  <div class="d-flex">
                    <feather-icon
                      icon="MailIcon"
                      size="19"
                    />
                    <h4 class="mb-0 ml-50">
                      Endereço
                    </h4>
                  </div>
                  <b-row>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="Contato"
                        rules="required"
                      >
                        <b-form-group
                          label="Contato"
                          label-for="contato"
                        >
                          <b-form-input
                            id="contato"
                            v-model="workplaceLocal.contact"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Contato"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        label="Telefone"
                        label-for="telefone"
                      >
                        <validation-provider
                          #default="validationContext"
                          name="Telefone"
                          vid="phone"
                          rules="required|min:10"
                        >
                          <cleave
                            id="phone"
                            v-model="workplaceLocal.phone"
                            class="form-control"
                            :raw="true"
                            :class="{'is-invalid': validationContext.errors.length}"
                            :options="options.phone"
                            placeholder="Telefone"
                          />
                          <small
                            v-if="validationContext.touched || validationContext.errors[0]"
                            class="text-danger"
                          >{{ validationContext.errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        label="CEP"
                        label-for="CEP"
                      >
                        <validation-provider
                          #default="{ errors, touched }"
                          name="CEP"
                          vid="CEP"
                          rules="required|min:8"
                        >
                          <cleave
                            id="CEP"
                            v-model="workplaceLocal.address.postal_code"
                            class="form-control"
                            :raw="true"
                            placeholder="CEP"
                            :options="options.postalCode"
                            :class="{'is-invalid': errors.length}"
                            @blur="searchCep(workplaceLocal.address)"
                          />
                          <small v-if="touched" class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="state"
                        rules="required"
                      >
                        <b-form-group
                          label="Estado"
                          label-for="state"
                        >
                          <v-select
                            v-model="selectedState"
                            autocomplete="state"
                            :options="stateOptions"
                            :clearable="false"
                            label="text"
                            :reduce="value => value.value"
                            input-id="state"
                            placeholder="Estado"
                            :disabled="!stateOptions.length"
                            :state="getValidationState(validationContext)"
                            @input="refreshCities(selectedState)"
                          />
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="city"
                        rules="required"
                      >
                        <b-form-group
                          label="Cidade"
                          label-for="cidade"
                        >
                          <v-select
                            v-model="selectedCity"
                            autocomplete="city"
                            :options="cityOptions"
                            :clearable="false"
                            label="text"
                            :reduce="value => value.value"
                            input-id="city"
                            placeholder="Cidade"
                            :disabled="!cityOptions.length"
                            :state="getValidationState(validationContext)"
                          />
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="Bairro"
                        rules="required"
                      >
                        <b-form-group
                          label="Bairro"
                          label-for="bairro"
                        >
                          <b-form-input
                            id="bairro"
                            v-model="workplaceLocal.address.neighborhood"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Bairro"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="12"
                      md="8"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="rua"
                        rules="required"
                      >
                        <b-form-group
                          label="Rua"
                          label-for="rua"
                        >
                          <b-form-input
                            id="rua"
                            v-model="workplaceLocal.address.street"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Rua"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                    >
                      <validation-provider
                        #default="validationContext"
                        name="número"
                        rules="required"
                      >
                        <b-form-group
                          label="Número"
                          label-for="número"
                        >
                          <b-form-input
                            id="número"
                            v-model="workplaceLocal.address.number"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Número"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <validation-provider
                    #default="validationContext"
                    name="complement"
                  >
                    <b-form-group
                      label="Complemento"
                      label-for="complemento"
                    >
                      <b-form-input
                        id="complemento"
                        v-model="workplaceLocal.address.complement"
                        autofocus
                        trim
                        placeholder="Complemento"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab>
              <template #title>
                <div>
                  <feather-icon
                    icon="DollarSignIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                  />
                  <span class="d-none d-sm-inline">
                    Tipos
                  </span>
                </div>
              </template>

              <b-row>
                <b-card
                  v-for="(duty, i) in workplaceLocal.duties"
                  :key="`duty-${duty.id}`"
                  overlay
                  no-body
                  class="my-1 ml-1 p-1 border"
                >
                  <div class="duty-header">
                    <b-button
                      variant="outlined"
                      class="mr-1 duty-remove"
                      :disabled="workplaceLocal.duties.length === 1"
                      @click="removeDuty(duty.id)"
                    >
                      <feather-icon
                        class="-m-1 cursor-pointer"
                        icon="XIcon"
                        size="16"
                      />
                    </b-button>
                  </div>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <validation-provider
                      :name="`profession_id-${duty.id}`"
                      rules="required"
                    >
                      <b-form-group
                        label="Profissão"
                        :label-for="`profession_id-${duty.id}`"
                      >
                        <!--                        sedf-->
                        <v-select
                          v-model="duty.profession_id"
                          autocomplete="type"
                          :options="professionOptions"
                          label="label"
                          placeholder="Profissão"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="value"
                        />
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                      :name="`duty_type_id-${duty.id}`"
                      rules="required"
                    >
                      <b-form-group
                        label="Especialidade"
                        :label-for="`duty_type_id-${duty.id}`"
                      >
                        <v-select
                          v-model="duty.duty_type_id"
                          autocomplete="type"
                          :options="dutyTypesOptions"
                          :clearable="false"
                          label="type"
                          item-value="id"
                          item-text="type"
                          :reduce="value => value.id"
                          placeholder="Tipo"
                          input-id="type"
                          @input="changeDutyType(duty)"
                        >
                          <span slot="no-options">Nenhuma profissão cadastrada</span>
                        </v-select>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                      #default="{ errors }"
                      :name="`duty_type_complement-${duty.id}`"
                    >
                      <b-form-group
                        label="Tipo complemento"
                        :label-for="`duty_type_complement-${duty.id}`"
                      >
                        <b-form-input
                          :id="`duty_type_complement-${duty.id}`"
                          v-model="duty.complement"
                          :state="errors.length > 0 ? false:null"
                          class="form-control-merge"
                          :name="`duty_type_complement-${duty.id}`"
                          autocomplete="off"
                          placeholder=""
                          :disabled="!!duty.service_type"
                        />
                      </b-form-group>
                    </validation-provider>
                    <div
                      v-for="(remuneration, index) in Object.keys(duty.remuneration)"
                      :key="`remuneration-${duty.id}-${index}`"
                    >
                      <validation-provider
                        #default="{ errors, touched }"
                        :name="`Valor hora ${getRemunerationType(remuneration)}`"
                        :vid="`duty-${i}`"
                        rules="required"
                      >
                        <b-form-group>
                          <label :for="`duty-${i}`" class="d-block duty-label">
                            Valor hora <b>{{ getRemunerationType(remuneration) }}</b> <span>({{ getNumberAsText(duty.remuneration[remuneration]) || 'zero reais' }})</span>
                          </label>
                          <cleave
                            :id="`duty-${i}`"
                            v-model="duty.remuneration[remuneration]"
                            class="form-control"
                            :class="{'is-invalid': touched && errors.length}"
                            :options="options.number"
                            :raw="true"
                            :disabled="!!duty.service_type"
                          />
                          <small v-if="touched" class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </b-col>
                </b-card>
                <div class="d-flex flex-column justify-content-center">
                  <b-button
                    variant="success"
                    class="m-1"
                    type="submit"
                    :disabled="workplaceLocal.duties.length === dutyTypesOptions.length"
                    @click="addDuty"
                  >
                    <feather-icon
                      class="-m-1 cursor-pointer"
                      icon="PlusIcon"
                      size="24"
                    />
                  </b-button>
                </div>
              </b-row>
            </b-tab>

            <b-tab>
              <template #title>
                <div>
                  <feather-icon
                    icon="UsersIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                  />
                  <span class="d-none d-sm-inline">
                    CNPJ Profissionais
                  </span>
                </div>
              </template>

              <b-row>
                <b-card no-body>
                  <b-card-body>
                    <b-row>
                      <!-- Per Page -->
                      <b-col
                        class="m-1 mt-lg-0 d-flex align-items-center justify-content-start"
                        cols="12"
                        md="12"
                        lg="12"
                      >
                        <div class="d-flex align-items-center justify-content-end w-100">
                          <b-button class="ml-1" variant="primary" @click="openImportModal">
                            <span class="text-nowrap">
                              Novo Profissional
                            </span>
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                    <b-table
                      ref="refWorkplaceListTable"
                      class="position-relative"
                      :items="workplaceLocal.physician_companies"
                      responsive
                      :fields="tableColumns"
                      primary-key="id"
                      show-empty
                      empty-text="Nenhum registro correspondente encontrado"
                    >
                      <template #cell(status)="{item}">
                        <b-badge
                          pill
                          :variant="item.status === 'processed' ? 'light-success' : ''"
                        >
                          {{ getPhysicianStatus(item.status) }}
                        </b-badge>
                      </template>
                      <template #cell(actions)="data">
                        <b-dropdown
                          v-if="data.item.new"
                          variant="link"
                          no-caret
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="align-middle text-body"
                            />
                          </template>
                          <b-dropdown-item

                            @click="removeCnpj(data.item)"
                          >
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Remover</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </b-table>
                  </b-card-body>
                </b-card>
              </b-row>
            </b-tab>
          </b-tabs>

          <b-row>
            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-1 mr-1"
                type="submit"
              >
                Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <b-modal
        id="modal-import"
        ref="importModal"
        title="Adicionar CNPJ"
        hide-footer
        no-close-on-backdrop
      >
        <b-form-group
          label="Profissional (CNPJ)"
          label-for="physician"
        >
          <v-select
            key="physician_company_id"
            v-model="companiesLocal"
            :filter="filterPhysicianCompany"
            :options="companyOptionsComputed"
            label="physician_company_id"
            :get-option-key="(d) => d.physician_company_id"
            input-id="physician_company_id"
            multiple
          >
            <template #no-options>
              <div>Nenhum profissional encontrato</div>
            </template>
            <template #option="{ name, company_name, company_cnpj }">
              <span class="text-truncate d-inline-block" style="max-width: 300px">
                {{ name }}
              </span>
              <div class="text-secondary text-truncate" style="max-width: 300px">
                {{ company_name }} |
                {{ formatCnpj(company_cnpj) }}
              </div>
            </template>

            <template #selected-option="{ name, company_name }">
              <span class="text-truncate d-inline-block" style="max-width: 280px">
                {{ name }} | {{ company_name }}
              </span>
            </template>
          </v-select>
        </b-form-group>

        <div class="d-flex align-items-end">
          <div class="text-right mt-2">
            <b-button class="ml-1" variant="primary" @click="addCnpj">
              <span class="text-nowrap">
                Adicionar
              </span>
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </component>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import {
  BCard,
  BTab,
  BTabs,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
  BRow,
  BCol,
  BCardBody,
  BTable,
  BModal, BDropdownItem, BDropdown, BBadge,
} from 'bootstrap-vue'
import slugify from 'slugify'
import Ripple from 'vue-ripple-directive'
import { uniq } from 'lodash'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, url } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  computed, onUnmounted, ref, toRefs,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// import { Money } from 'v-money'
import store from '@/store'
import workplaceStoreModule from '@/views/workplace/workplaceStoreModule'
import useWorkplaceHandler from '@/views/workplace/workplace-form/useWorkplaceHandler'
import cep from 'cep-promise'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import { formatCnpj, formatCpf, numberAsText } from '@core/utils/utils'
import Fuse from 'fuse.js'

export default {
  components: {
    BBadge,
    BDropdown,
    BDropdownItem,

    BModal,
    BTable,
    BCardBody,
    BCard,
    BTab,
    BTabs,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    Cleave,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      email,
      url,
      options: {
        number: {
          numeralPositiveOnly: true,
          numericOnly: true,
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          prefix: 'R$ ',
          rawValueTrimPrefix: true,
        },
        phone: {
          delimiters: ['(', ') ', '-'],
          blocks: [0, 2, 5, 4],
          numericOnly: true,
        },
        postalCode: {
          delimiters: ['.', '-'],
          blocks: [2, 3, 3],
          numericOnly: true,
        },
      },
    }
  },
  methods: {
    formatCnpj,
    getNumberAsText: numberAsText,
  },
  setup(props, { emit }) {
    const toast = useToast()

    const WORKPLACE_STORE = 'app-workplace'
    if (!store.hasModule(WORKPLACE_STORE)) { store.registerModule(WORKPLACE_STORE, workplaceStoreModule) }
    onUnmounted(() => {
      if (store.hasModule(WORKPLACE_STORE)) { store.unregisterModule(WORKPLACE_STORE) }
    })

    const companyOptions = ref([])
    const importModal = ref(null)
    const companiesLocal = ref([])
    const selectedState = ref('')
    const selectedCity = ref('')
    const dutyTypesOptions = ref([])
    const professionOptions = ref([])
    const blankWorkplace = {
      name: '',
      contact: '',
      phone: '',
      address: {
        city_id: '',
      },
      duties: [
        {
          id: uuidv4(),
          duty_type_id: '',
          complement: '',
          service_type: null,
          remuneration: {
            week: 0,
            weekend: 0,
          },
        },
      ],
      physician_companies: [],
    }
    const workplaceLocal = ref(JSON.parse(JSON.stringify(blankWorkplace)))

    const resetWorkplaceData = () => {
      workplaceLocal.value = JSON.parse(JSON.stringify(blankWorkplace))
    }

    const openImportModal = () => {
      importModal.value.show()
    }

    const addCnpj = () => {
      const companies = companiesLocal.value.map(company => ({
        id: company.id,
        physician: {
          cpf: company.cpf,
          name: company.name,
        },
        physician_company: {
          name: company.company_name,
          cnpj: company.company_cnpj,
        },
        physician_company_id: company.physician_company_id,
        reason: '',
        limit: 1,
        status: 'pending',
        new: true,
      }))
      workplaceLocal.value.physician_companies.unshift(...companies)
      companiesLocal.value = []
      importModal.value.hide()
    }

    const removeCnpj = item => {
      const index = workplaceLocal.value.physician_companies.findIndex(d => d.physician_company_id === item.physician_company_id)
      workplaceLocal.value.physician_companies.splice(index, 1)
    }

    const getPhysicianStatus = status => {
      if (status === 'active') {
        return 'Ativo'
      }
      if (status === 'denied') {
        return 'Recusado'
      }
      return status === 'approved' ? 'Aprovado' : 'Pendente'
    }

    const tableColumns = [
      { key: 'physician_company.cnpj', label: 'CNPJ', formatter: formatCnpj },
      { key: 'physician_company.name', label: 'Empresa' },
      { key: 'physician.name', label: 'Profissional' },
      { key: 'physician.cpf', label: 'CPF', formatter: formatCpf },
      { key: 'status', label: 'Status' },
      { key: 'actions', label: 'Ações' },
    ]

    const {
      refFormObserver,
      getValidationState,
      clearForm,
    } = formValidation(resetWorkplaceData)

    store.dispatch(`${WORKPLACE_STORE}/dutyTypes`)
      .then(({ data }) => {
        dutyTypesOptions.value = data.data
      })
    store.dispatch(`${WORKPLACE_STORE}/fetchProfessions`)
      .then(({ data }) => {
        professionOptions.value = data.data.map(p => ({
          label: p.label,
          value: p.id,
        }))
      })

    const {
      fetchStates,
      fetchCities,
      stateOptions,
      cityOptions,
      payDayOptions,
      paymentMonthOptions,
    } = useWorkplaceHandler(toRefs(props), emit)

    const getDutyId = duty => `${duty.duty_type_id}-${duty.profession_id}${slugify(duty.complement || '', { lower: true })}`

    store.dispatch('app-workplace/fetchPhysiciansCnpj')
      .then(async response => {
        companyOptions.value = response.data.data
      })

    if (router.currentRoute.params.id) {
      fetchStates()
        .then(() => store.dispatch('app-workplace/fetchWorkplace', { id: router.currentRoute.params.id }))
        .then(async response => {
          const duties = {}
          response.data.data.duties.forEach(duty => {
            if (!duties[getDutyId(duty)]) {
              duties[getDutyId(duty)] = {
                id: uuidv4(),
                profession_id: duty.profession_id,
                duty_type_id: duty.duty_type_id,
                service_type: duty.service_type,
                complement: duty.complement,
                remuneration: {
                  week: 0,
                  weekend: 0,
                },
              }
            }
            const remuneration = duty.remuneration / 100
            const formatted = String(remuneration).replace('.', ',')
            duties[getDutyId(duty)].remuneration[duty.value_modifier_type] = formatted
          })
          const workplace = response.data.data
          const stateId = workplace.address[0].city.state.id
          if (stateId) await fetchCities(stateId)
          selectedCity.value = workplace.address[0].city.id
          selectedState.value = stateId
          workplaceLocal.value = {
            ...workplace,
            duties: Object.values(duties),
            address: {
              complement: workplace.address[0].complement,
              neighborhood: workplace.address[0].neighborhood,
              number: workplace.address[0].number,
              postal_code: workplace.address[0].postal_code,
              street: workplace.address[0].street,
              city_id: workplace.address[0].city.id,
            },
          }
        })
    } else {
      clearForm()
      fetchStates()
    }

    function changeDutyType(duty) {
      const d = dutyTypesOptions.value.find(({ id }) => id === duty.duty_type_id)
      // eslint-disable-next-line no-param-reassign
      duty.service_type = d.service_type
    }

    function addDuty() {
      let professionId = null
      if (professionOptions.value.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        professionId = professionOptions.value[0].value
      }

      workplaceLocal.value.duties.push({
        id: uuidv4(),
        profession_id: professionId,
        duty_type_id: '',
        complement: '',
        service_type: null,
        remuneration: {
          week: 0,
          weekend: 0,
        },
      })
    }

    async function refreshCities(stateId) {
      const cities = await fetchCities(stateId)
      selectedCity.value = cities[0].value
    }

    function searchCep(address) {
      if (!address.postal_code || address.postal_code.length < 8) return
      cep(address.postal_code)
        .then(async data => {
          /* eslint-disable no-param-reassign */
          const state = stateOptions.value.find(s => s.text === data.state)
          if (state) selectedState.value = state.value
          await fetchCities(state.value)
          const city = cityOptions.value.find(s => s.text === data.city)
          if (city) {
            address.city_id = city.value
            selectedCity.value = city.value
          }
          address.street = data.street
          address.neighborhood = data.neighborhood
        })
    }

    function save() {
      const workplace = workplaceLocal.value
      workplace.address.city_id = selectedCity.value
      const dutyTypes = workplace.duties.map(d => getDutyId(d))
      if (uniq(dutyTypes).length !== dutyTypes.length) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Tipos de escala duplicados',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return
      }

      const getRemunerations = d => {
        const remunerations = {}
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const duration in d.remuneration) {
          remunerations[duration] = parseInt(d.remuneration[`${duration}`] * 100, 10)
        }
        return remunerations
      }

      const physicianCompanies = workplace.physician_companies.map(p => ({
        id: p.physician_company_id,
      }))

      const duties = []
      workplace.duties.forEach(d => {
        if (d.service_type) {
          duties.push({
            ...d, value_modifier_type: 'week', duration: 1, remuneration: 0,
          })
        } else {
          const remunerations = getRemunerations(d)
          Object.keys(remunerations).forEach(type => {
            duties.push({
              ...d, value_modifier_type: type, duration: 1, remuneration: remunerations[type],
            })
          })
        }
      })

      const submittedValue = {
        id: workplace.id,
        name: workplace.name,
        contact: workplace.contact,
        phone: workplace.phone,
        address: workplace.address,
        duties,
        physician_companies: physicianCompanies,
      }
      submittedValue.address.complement = submittedValue.address.complement || null
      store.dispatch(`app-workplace/${submittedValue.id ? 'updateWorkplace' : 'addWorkplace'}`, JSON.parse(JSON.stringify(submittedValue)))
        .then(() => {
          router.push('/workplaces')
        }).catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: `Erro ao ${submittedValue.id ? 'editar' : 'adicionar'} unidade`,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    function getRemunerationType(type) {
      if (type === 'week') return 'dia de semana'
      return 'final de semana'
    }

    function removeDuty(id) {
      const index = workplaceLocal.value.duties.findIndex(d => d.id === id)
      workplaceLocal.value.duties.splice(index, 1)
    }

    function filterPhysicianCompany(options, search) {
      const fuse = new Fuse(options, {
        keys: ['company_cnpj', 'company_name', 'cpf', 'email', 'name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    }

    const companyOptionsComputed = computed(() => {
      const ids = workplaceLocal.value.physician_companies.map(p => p.physician_company_id)
      return companyOptions.value.filter(c => !ids.includes(c.physician_company_id))
    })

    return {
      companyOptions,
      companyOptionsComputed,
      filterPhysicianCompany,
      companiesLocal,
      addCnpj,
      removeCnpj,
      importModal,
      openImportModal,
      getRemunerationType,
      getPhysicianStatus,
      addDuty,
      workplaceLocal,
      refFormObserver,
      getValidationState,
      stateOptions,
      payDayOptions,
      paymentMonthOptions,
      cityOptions,
      save,
      selectedState,
      selectedCity,
      dutyTypesOptions,
      professionOptions,
      removeDuty,
      refreshCities,
      searchCep,
      changeDutyType,
      tableColumns,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.card-header {
  padding: 0!important;
}
.duty-header {
  display: block;
  text-align: end;
}

.duty-remove {
  padding: 0.05rem;
}

.duty-label span {
  max-width: 250px;
  display: block;
  font-size: 10px;
}
</style>
